(function(){'use strict';
// Hydrates <time data-relative datetime="..."> elements into a human
// relative string. Caps at 12h — anything older returns null and we
// disable the parent rotation so we never display stale momentum.
// Also pins the parent subline to its alt copy (.is-stuck-alt) when
// the timestamp is under an hour old — "Last sold N minutes ago" is
// more compelling than rotating back to the tier offer, so the JS
// ticker stays running but visually the alt is locked in.
function relStr(d){
  // Never say "just now" — a multi-product order placed seconds before
  // the customer browses would otherwise show "just now" across every
  // shirt in that order, which reads as fake / scripted. Floor the
  // bottom of the range at "1 minute ago" so the social-proof copy
  // always feels grounded in actual elapsed time.
  if(d<120)return'1 minute ago';
  if(d<3600)return Math.floor(d/60)+' minutes ago';
  if(d<7200)return'1 hour ago';
  return Math.floor(d/3600)+' hours ago';
}
function hydrateCartLastSold(){
  // Cart line-item "Last sold X minutes ago" — fresh-only (<60 min).
  // When inside .wc-cart-momentum (paired with "X+ bought in past month"):
  //   fresh → add .is-rotating to parent to enable the alternating fade.
  //   stale → remove the alt element entirely so only the primary shows
  //           (no rotation, no empty grid cell).
  // When standalone (no primary sibling):
  //   fresh → add .is-fresh to display the element.
  //   stale → leave it hidden via the default :not(.is-fresh) display:none.
  var nodes=document.querySelectorAll('[data-wc-cart-last-sold]');
  for(var i=0;i<nodes.length;i++){
    var el=nodes[i];
    var timeEl=el.querySelector('[data-recent-sale-time]');
    if(!timeEl)continue;
    var s=timeEl.getAttribute('datetime');
    if(!s)continue;
    var t=new Date(s).getTime();
    if(isNaN(t))continue;
    var d=Math.max(0,(Date.now()-t)/1000);
    var inRotation=el.classList.contains('wc-cart-momentum__alt');
    var parent=el.parentElement;
    if(d<3600){
      timeEl.textContent=relStr(d);
      el.classList.add('is-fresh');
      if(inRotation&&parent)parent.classList.add('is-rotating');
    }else if(inRotation&&parent){
      el.parentNode.removeChild(el);
    }
  }
}
function hydrateRecentSaleOverlays(){
  // Card-image overlays: show only when last_purchased_at is within 59 min.
  // Snippet renders display:none by default; we add .is-fresh to reveal.
  // Cycle 29: card overlays render only with Theme settings "Show 'Last sold'
  // on cards" on (default off). No overlay or trending markup = nothing to do.
  var overlays=document.querySelectorAll('[data-wc-recent-sale]');
  if(!overlays.length&&!document.querySelector('[data-wc-trending-sale]'))return;
  for(var i=0;i<overlays.length;i++){
    var el=overlays[i];
    var timeEl=el.querySelector('[data-recent-sale-time]');
    if(!timeEl)continue;
    var s=timeEl.getAttribute('datetime');
    if(!s)continue;
    var t=new Date(s).getTime();
    if(isNaN(t))continue;
    var d=Math.max(0,(Date.now()-t)/1000);
    if(d<3600){
      timeEl.textContent=relStr(d);
      el.classList.add('is-fresh');
      el.setAttribute('aria-hidden','false');
    }
  }
  applyTrendingSupplement();
}
// Page-quota supplement (collection grid only): when fewer than TREND_QUOTA
// cards show a FRESH "last sold" badge, reveal "Trending! X sold today" on
// cards that have a 24h count (sold_24h) but no fresh sale. Mutually exclusive
// with the fresh badge per card; re-runs as endless scroll appends cards.
function applyTrendingSupplement(){
  var grid=document.getElementById('product-grid');
  if(!grid)return;
  var TREND_QUOTA=10;
  var fresh=grid.querySelectorAll('[data-wc-recent-sale].is-fresh').length;
  var trend=grid.querySelectorAll('[data-wc-trending-sale]');
  for(var j=0;j<trend.length;j++){
    var tEl=trend[j];
    var p=tEl.parentNode;
    var hasFresh=p&&p.querySelector('[data-wc-recent-sale].is-fresh');
    if(fresh<TREND_QUOTA&&!hasFresh){
      tEl.classList.add('is-trending');
      tEl.setAttribute('aria-hidden','false');
    }else{
      tEl.classList.remove('is-trending');
      tEl.setAttribute('aria-hidden','true');
    }
  }
}
function r(){
  hydrateRecentSaleOverlays();
  hydrateCartLastSold();
  var els=document.querySelectorAll('time[data-relative]');
  for(var i=0;i<els.length;i++){
    var s=els[i].getAttribute('datetime');
    var t=s?new Date(s).getTime():NaN;
    // No concrete, parseable timestamp → the copy would read "Last sold
    // recently" (the server placeholder relStr never produces). NEVER rotate to
    // that: disarm the parent tier subline so CSS hides the alt and leaves only
    // the tier offer. (Stale >12h is disarmed below; this covers missing/bad.)
    // No-promo subline (wc-tier-subline.liquid with BMSM OFF) carries ONLY the
    // "Last sold" copy, so a missing/stale timestamp means the whole line goes —
    // removed (not hidden) so .wc-atc-btn:has(.wc-tier-subline) stops matching.
    var npSub=els[i].closest('.wc-tier-subline--nopromo');
    if(npSub&&(!s||isNaN(t)||Math.max(0,(Date.now()-t)/1000)>43200)){npSub.parentNode.removeChild(npSub);continue;}
    if(!s||isNaN(t)){
      var badSub=els[i].closest('.wc-tier-subline[data-has-recent-sale]');
      if(badSub){badSub.removeAttribute('data-has-recent-sale');badSub.classList.remove('is-alt','is-stuck-alt');}
      continue;
    }
    var d=Math.max(0,(Date.now()-t)/1000);
    if(d>43200){
      // Stale timestamp. If inside a rotating tier subline, disable rotation
      // so we never flip to an empty alt; otherwise hide just the local line.
      var staleSub=els[i].closest('.wc-tier-subline[data-has-recent-sale]');
      if(staleSub){staleSub.removeAttribute('data-has-recent-sale');staleSub.classList.remove('is-alt','is-stuck-alt');}
      else{var p=els[i].closest('.wc-velocity__line')||els[i].parentNode;if(p)p.style.display='none';}
      continue;
    }
    els[i].textContent=relStr(d);
    // Under an hour → pin the parent subline to the alt copy.
    if(d<3600){
      var freshSub=els[i].closest('.wc-tier-subline[data-has-recent-sale]');
      if(freshSub)freshSub.classList.add('is-stuck-alt');
    }
  }
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',r);}else{r();}
// Grid changed (endless-scroll append / size filter) — re-hydrate the overlays
// and re-run the trending supplement on the new cards. wc-collection-more.js and
// wc-size-filter.js dispatch this event after they mutate the grid.
var _wcReTimer;
document.addEventListener('wc:quickadd-refresh',function(){
  clearTimeout(_wcReTimer);
  _wcReTimer=setTimeout(hydrateRecentSaleOverlays,60);
});
// Re-hydrate the cart drawer whenever its contents change. Dawn-style themes
// re-render the cart drawer HTML on add/remove/qty (via /cart.js sync), which
// wipes any classes we previously added. We can't rely on PUB_SUB_EVENTS
// because it's module-scoped in this theme (not on window), so we use a
// MutationObserver instead — theme-agnostic and catches every kind of update.
function watchCartDrawer(){
  var drawer=document.querySelector('cart-drawer')||document.querySelector('.cart-drawer');
  if(!drawer){setTimeout(watchCartDrawer,500);return;}
  var pending=false;
  var obs=new MutationObserver(function(){
    if(pending)return;
    // Only re-hydrate if there are unhydrated targets — avoids feedback loop
    // since adding .is-fresh itself triggers a mutation.
    if(!drawer.querySelector('[data-wc-cart-last-sold]:not(.is-fresh)'))return;
    pending=true;
    setTimeout(function(){pending=false;hydrateCartLastSold();},50);
  });
  obs.observe(drawer,{childList:true,subtree:true});
  // Hydrate once immediately in case the drawer was already populated.
  hydrateCartLastSold();
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',watchCartDrawer);}else{watchCartDrawer();}
})();
